import { put, take } from "redux-saga/effects";
import { store } from "../../store";

import { REQUEST_LOCALES_SUCCESS, requestLocales } from "../../actions/locales";

import { setLocale } from "../../actions/controllers/locale";

export function* fetchLocales() {
  // Fetch locales
  yield put(requestLocales());
  yield take(REQUEST_LOCALES_SUCCESS);

  // Select locale
  let locale = "nl_NL"; // Default locale
  let state = store.getState();

  // Try to get cookie
  let cookieLocale = (match => (match ? match[2] : undefined))(
    document.cookie.match(/(^| )locale=([^;]+)/)
  );

  // Fall back on browser language
  let userLang = (cookieLocale || require("browser-locale")()).substring(0, 2);

  // Try to match found locale with availiable
  if (state.locales && state.locales.data) {
    for (let i in state.locales.data) {
      let loc = state.locales.data[i];
      if (loc.startsWith(userLang)) {
        locale = loc;
      }
    }
  }
  yield put(setLocale(locale));
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/fetchLocales.js